import { Header, Wrapper } from "@wisr/react-ui";
import React from "react";

import appleIcon from "../../assets/images/apple-touch-icon.png";
import faviconFull from "../../assets/images/favicon.png";
import faviconSmall from "../../assets/images/favicon-16x16.png";
import faviconBig from "../../assets/images/favicon-32x32.png";
import { FooterComponent } from "./footer/footer.component";
import { HelmetSeoComponent } from "./helmet-seo.component";
import globalStyle from "./application-layout.global.scss";
import localStyle from "./application-layout.scss";
import { getHeaderContent, LayoutType } from "./application-layout.utils";
import { MultiPageFormProgress } from "./multi-page-form-progress/multi-page-form-progress";
import { VersionComponent } from "../version.component";

import { isDebugMode } from "../../shared/config.utils";
import { GatsbyPageLocation } from "../../types/gatsby";
import { brazeLoaded } from "../../shared/analytics/analytics.utils";
import { InAppMessage } from "../../types/in-app-message";

interface PropTypes {
  layoutType?: LayoutType;
  setSupportModal?: (arg0: boolean) => void;
  location?: GatsbyPageLocation;
}

export const ApplicationLayout: React.FunctionComponent<PropTypes> = (
  props
) => {
  const { children, layoutType = "default", setSupportModal, location } = props;

  const headerContent = getHeaderContent({
    layoutType: layoutType,
    setSupportModal: setSupportModal,
  });

  React.useEffect(() => {
    if (brazeLoaded()) {
      window.appboy.subscribeToInAppMessage((inAppMessage: InAppMessage) => {
        window.appboy.display.showInAppMessage(inAppMessage);
      });
    }
  }, []);

  return (
    <Wrapper>
      <style jsx>{globalStyle}</style>
      <style jsx>{localStyle}</style>
      <HelmetSeoComponent
        title="Wisr Personal Loan Application Form"
        description="Get a rate estimate in minutes – with no impact to your credit score. Use it to understand your borrowing power before you apply for a Wisr personal loan."
      >
        <link
          key="apple-icon"
          rel="apple-touch-icon"
          sizes="180x180"
          href={appleIcon}
        />
        <link
          key="favicon-512"
          rel="icon"
          type="image/png"
          sizes="512x512"
          href={faviconFull}
        />
        <link
          key="favicon-32"
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={faviconBig}
        />
        <link
          key="favicon-16"
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={faviconSmall}
        />
      </HelmetSeoComponent>

      <div className={`header ${layoutType}`}>
        <Header content={headerContent} />
        {layoutType === "multi-page-form" && (
          <MultiPageFormProgress location={location} />
        )}
      </div>

      <div className={`${layoutType}-body`}>{children}</div>

      <FooterComponent layoutType={layoutType} />
      {isDebugMode() && <VersionComponent />}
    </Wrapper>
  );
};
